import GisViewer from './MapContainer.vue';
export default GisViewer;
